import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import special from "../styles/special.module.scss";
import { UserContext } from "../context/UserContext";
import {
  changePassword,
  passwordErrorMessage,
} from "../utilities/passwordAccount";

function ChangePassword() {
  const navigate = useNavigate();
  const { userInformation } = useContext(UserContext);
  const [currentPassword, setCurrentPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [completed, setCompleted] = useState(false);

  const visualStyle = {
    backgroundImage: `linear-gradient(180deg, rgba(8, 12, 12, 0.12), rgba(8, 12, 12, 0.84)), url(${process.env.PUBLIC_URL}/images/contact.jpg)`,
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage("");

    if (password.length < 8) {
      setMessage("Password must be at least 8 characters.");
      return;
    }

    if (password !== confirmPassword) {
      setMessage("Passwords do not match.");
      return;
    }

    setLoading(true);

    try {
      await changePassword({ currentPassword, password });
      setCompleted(true);
    } catch (error) {
      setMessage(passwordErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={special.contactShell}>
      <div className={special.contactPage}>
        <div className={special.contactBackdrop}></div>
        <div className={special.contactFrame}>
          <div className={special.contactVisual} style={visualStyle}>
            <div className={special.contactVisualOverlay}></div>
            <div className={special.contactVisualCopy}>
              <p className={special.contactVisualEyebrow}>Account</p>
              <h2>Change your password.</h2>
              <p>
                {userInformation.email
                  ? `This updates the password for ${userInformation.email}.`
                  : "Choose a new password for this Matlib account."}
              </p>
            </div>
          </div>

          {completed ? (
            <div className={special.contactForm}>
              <h1>Password updated</h1>
              <p className={special.contactIntro}>
                Use the new password the next time you sign in.
              </p>
              <div className={special.registerActions}>
                <button
                  type="button"
                  className={special.contactButton}
                  onClick={() => navigate("/library")}
                >
                  Back to library
                </button>
              </div>
            </div>
          ) : (
            <form className={special.contactForm} onSubmit={handleSubmit}>
              <h1>Change password</h1>
              <p className={special.contactIntro}>
                Enter your current password, then choose a new one.
              </p>

              <div className={special.contactInputGroup}>
                <label htmlFor="current-password">Current password</label>
                <input
                  id="current-password"
                  type="password"
                  autoComplete="current-password"
                  value={currentPassword}
                  onChange={(event) => setCurrentPassword(event.target.value)}
                />
              </div>

              <div className={special.contactInputGroup}>
                <label htmlFor="new-password">New password</label>
                <input
                  id="new-password"
                  type="password"
                  autoComplete="new-password"
                  placeholder="At least 8 characters"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                />
              </div>

              <div className={special.contactInputGroup}>
                <label htmlFor="confirm-new-password">Confirm new password</label>
                <input
                  id="confirm-new-password"
                  type="password"
                  autoComplete="new-password"
                  value={confirmPassword}
                  onChange={(event) => setConfirmPassword(event.target.value)}
                />
              </div>

              {message ? (
                <div className={special.registerErrorMessage}>{message}</div>
              ) : null}

              <div className={special.registerActions}>
                <button
                  type="submit"
                  className={special.contactButton}
                  disabled={loading}
                >
                  {loading ? "Saving..." : "Save password"}
                </button>
                <button
                  type="button"
                  className={special.registerSecondaryButton}
                  onClick={() => navigate("/library")}
                >
                  Cancel
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;
